import React, { forwardRef } from "react";
import "./H3.scss";

const H3 = forwardRef((props, ref) => {
  const { text, style } = props;

  return (
    <h3 style={style} className={'h3_subtitle'}>
      {text}
    </h3>
  );
});

export default H3;
